import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { map } from 'rxjs';
import { RoughagePlusEvent } from 'src/app/models/events.model';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import MonitorActions from '../monitor/actions';

@Injectable()
export class ApplicationInsightsEffects {
  private readonly actions$ = inject(Actions);
  private readonly appInsightsService = inject(AppInsightsService);
  private readonly authenticationService = inject(AuthenticationService);

  appInsightsPageView$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        map(() => {
          if (this.authenticationService.isLoggedIn()) {
            this.appInsightsService.trackPageView();
          }
        }),
      ),
    { dispatch: false },
  );

  monitorSegmentChanged$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MonitorActions.setActiveMonitorSegment),
        map(({ segment }) => {
          this.appInsightsService.trackEvent(
            RoughagePlusEvent.MonitorSegmentChanged,
            {
              value: segment,
            },
          );
        }),
      ),
    { dispatch: false },
  );
}
